/**
 * Converts Rem to Pixels.
 * @param {Number} rem number of Rem
 * @returns {Number} number of pixels for the given rem number.
 */
export const remToPixels = (rem: number) =>
  rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
